class NewProductsService {
    constructor(restangular, $location, $q) {
        this.$location = $location;
        this._api = restangular.one('Products');
        this.isLoading = false;
        this.$q = $q;
        this.cache = {}; // Cache pure json response~ please don't cache promise or object coz it will get mutate
    }

    getProducts(pageSize, pageNumber, sortType, filters) {
        this.isLoading = true;
        let responsePromise;
        const key = [pageSize, pageNumber, sortType, filters ? JSON.stringify(filters) : filters].join('.');

        if (!(key in this.cache)) {
            responsePromise = this._api.post('New', {
                PageSize: pageSize,
                PageNumber: pageNumber,
                SortType: sortType,
                Filters: filters ? filters.filters : [],
                Location: this.$location.url(),
            }).then((response) => {
                this.cache[key] = JSON.stringify(response);
                return response;
            });
        } else {
            const deferred = this.$q.defer();
            deferred.resolve(JSON.parse(this.cache[key]));
            responsePromise = deferred.promise;
        }

        return responsePromise.then((response) => {
            this.totalRecordCount = response.TotalRecordCount;
            return response;
        }).finally(() => {
            this.isLoading = false;
        });
    }
}

module.exports = NewProductsService;



// WEBPACK FOOTER //
// ./src/shop/newproducts/newproducts.service.js